<template>
  <div id="sub-menu-link" v-if="mostrar">
    <div class="row">
      <div class="col-md-6">
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name:  'login' }" >
               <span class="active">Início</span>
            </router-link>
          </li>
          <li v-for="link in menuLink">

            <!-- <a :href="link.url" v-if="link.ativo != true">{{ link.titulo }}</a> -->

            <router-link :to="{ name:  link.name }"  v-if="link.ativo != true">
               <span class="active">{{ link.titulo }}</span>
            </router-link>

            <span class="active" v-else>{{ link.titulo }}</span>

          </li>
        </ol>
      </div>
      <div class="col-md-6">
        <div class="pull-right">
          <div class="btn-group" role="group" aria-label="...">

            <a class="btn btn-default" v-for="btn in menuBtn" :href="btn.url"
            :disabled="btn.ativo">{{ btn.titulo }}</a>

          </div>
        </div>
      </div>
  </div>

  </div>
</template>
<script>
export default {
  name: "sub-menu-link",
  props: {
      menuLink : Array,
      menuBtn : Array
  },

  data(){
    return{

    }
  },
  computed:{
    mostrar(){
      return this.menuLink.length > 0 ? true : false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especificos/SubMenuLink.vue